(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-carousel-global"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
    const $carousel = $('.carousel-alt-brands');

    const $items = $carousel.children();
    const itemCount = $items.length;

    $carousel.on('init', function(event, slick) {
      slick.$slider.css('visibility', 'visible');
    });

    $carousel.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 10000,
      cssEase: 'linear',
      infinite: true,
      variableWidth: true,
      arrows: false,
      pauseOnHover: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      waitForAnimate: false,
      responsive: [
      {
        breakpoint: 767, // Adjust this breakpoint as needed
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false // Set to false for mobile to ensure exactly 3 slides are shown
        }
      }
    ]
    });

    // Custom infinite loop handling
    $carousel.on('afterChange', function(event, slick, currentSlide) {
      if (currentSlide >= itemCount) {
        $carousel.slick('slickGoTo', currentSlide - itemCount, true);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module-faq-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');

    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();

        const contentId = this.getAttribute('data-accordion-trigger');
        const content = document.querySelector(`[data-accordion-content="${contentId}"]`);

        // Toggle active class
        this.classList.toggle('accordion-active');

        // Toggle content visibility
        if (content.style.display === 'none' || content.style.display === '') {
          content.style.display = 'block';
        } else {
          content.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const featureContents = document.querySelectorAll('.feature-content');

    featureContents.forEach((content) => {
      content.addEventListener('mouseenter', function () {
        featureContents.forEach((c) => c.classList.remove('active'));
        this.classList.add('active');
      });

      content.addEventListener('click', function () {
        featureContents.forEach((c) => c.classList.remove('active'));
        this.classList.add('active');
      });
    });

    // Optional: Handle mouse leaving the feature wrapper
    // const featureWrapper = document.querySelector('.feature-wrapper');
    // featureWrapper.addEventListener('mouseleave', function () {
    //   // Optional: Reset to the first item being active when mouse leaves the area
    //   featureContents[0].classList.add('active');
    // });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Initialize Slick Carousel
    $('.slick-carousel').slick({
      dots: false,
      arrows: false,
      autoplaySpeed: 3000,
      autoplay:true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slick-carousel-quotes',
    });

    $('.slick-carousel-quotes').slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slick-carousel',
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yellow-stripe-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const $carousel = $('.carousel-alt');

    const $items = $carousel.children();
    const itemCount = $items.length;

    $carousel.on('init', function(event, slick) {
      slick.$slider.css('visibility', 'visible');
    });

    $carousel.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 10000,
      cssEase: 'linear',
      infinite: true,
      variableWidth: true,
      arrows: false,
      pauseOnHover: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      waitForAnimate: false
    });

    // Custom infinite loop handling
    $carousel.on('afterChange', function(event, slick, currentSlide) {
      if (currentSlide >= itemCount) {
        $carousel.slick('slickGoTo', currentSlide - itemCount, true);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
